// Connessione Socket.IO dell'app: wrapper `$socket` del plugin (socket.client.ts) più lo stato di connessione della
// componente che lo usa. Un solo socket per tutta l'app.
export const useSocket = () => {
  const { $socket } = useNuxtApp();
  const isConnected = ref(false);

  // Socket grezzo (null finché non è connesso)
  const raw = () => $socket.get();

  const connect = (url: string) => $socket.ensureConnected(url);
  const disconnect = () => raw()?.disconnect();
  const emit = (event: string, data?: unknown) => $socket.emit(event, data);
  const on = (event: string, cb: (...args: any[]) => void) => $socket.on(event, cb);
  const off = (event: string, cb: (...args: any[]) => void) => $socket.off(event, cb);

  const sulConnect = () => (isConnected.value = true);
  const sulDisconnect = () => (isConnected.value = false);

  onMounted(() => {
    const s = raw();
    if (!s) return;
    s.on("connect", sulConnect);
    s.on("disconnect", sulDisconnect);
  });

  onUnmounted(() => {
    const s = raw();
    if (!s) return;
    // Solo i propri listener: `s.off("connect")` senza callback toglieva anche quelli degli altri (es. il ri-join delle room)
    s.off("connect", sulConnect);
    s.off("disconnect", sulDisconnect);
  });

  return { socket: $socket, isConnected, connect, disconnect, emit, on, off, raw, state: $socket.state };
};
